export enum ProgressFilterValue {
  NOT_STARTED = 'notStarted',
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
}

export enum PriorityFilterValue {
  MANDATORY = 'mandatory',
  OPTIONAL = 'optional',
}

export interface IFilter {
  courseProgress: ProgressFilterValue[]
  coursePriority: PriorityFilterValue[]
  term: string[]
  collection: string[]
}

export type FilterType = keyof IFilter

export type FilterDrawerType = 'catalog' | 'enrolled' | 'public'
